import { normalizeArabic } from "@/v2/utils";
import { TD, TR } from "@ag-media/react-pdf-table";
import { Text } from "@react-pdf/renderer";
import { Style } from "@react-pdf/types";
import { textStyles } from "../../common";

type ArabicEnabled = {
    disableArabicContent?: false;
    contentInArabic: string;
};

type ArabicDisabled = {
    disableArabicContent: true;
    contentInArabic?: never;
};

type BlockRowContentProps = {
    arabicLabel: string;
    englishLabel: string;
    content: string;
    boldContent?: boolean;
    style?: Style | Style[];
} & (ArabicEnabled | ArabicDisabled);

export default function BlockRowContent({
    arabicLabel,
    englishLabel,
    content,
    boldContent = false,
    style,
    contentInArabic,
    disableArabicContent = false,
}: BlockRowContentProps) {
    return (
        <TR style={{ ...style }}>
            <TD>{englishLabel}</TD>
            <TD
                style={{
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {!disableArabicContent && (
                    <Text
                        style={{
                            ...textStyles.arabicText,
                            textAlign: "center",
                            ...(boldContent ? { fontWeight: 800 } : {}),
                        }}
                    >
                        {normalizeArabic(contentInArabic) || "N/A"}
                    </Text>
                )}
                <Text
                    style={{
                        textAlign: "center",
                        ...(boldContent ? { fontWeight: 800 } : {}),
                    }}
                >
                    {content || "N/A"}
                </Text>
            </TD>

            <TD
                style={[
                    textStyles.arabicText,
                    {
                        justifyContent: "flex-start",
                    },
                ]}
            >
                {normalizeArabic(arabicLabel)}
            </TD>
        </TR>
    );
}
